import { render } from "./GlobalNav.vue?vue&type=template&id=0de3d02a&scoped=true"
import script from "./GlobalNav.vue?vue&type=script&lang=js"
export * from "./GlobalNav.vue?vue&type=script&lang=js"

import "./GlobalNav.vue?vue&type=style&index=0&id=0de3d02a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de3d02a"]])

export default __exports__